// Compact 0-10 photo opportunity score chip + a low-key bar.
// Used by Activities, Drives, Today.

export default function ConditionScore({ score, size = 'md', label = 'now' }) {
  const v = Math.round((score ?? 0) * 10) / 10;
  const tone = scoreTone(v);

  return (
    <div
      className={[
        'inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 font-mono text-xs uppercase tracking-wider',
        tone.border,
        tone.bg,
        tone.fg,
        size === 'sm' ? 'text-[10px]' : '',
      ].join(' ')}
      title={`Photo opportunity score (${label})`}
    >
      <span className="tabular-nums">{v.toFixed(1)}</span>
      <span className="opacity-60">/10</span>
      {label && <span className="ml-0.5 opacity-60">· {label}</span>}
    </div>
  );
}

function scoreTone(v) {
  if (v >= 7.5) {
    return { border: 'border-success/40', bg: 'bg-success/10', fg: 'text-success' };
  }
  if (v >= 5) {
    return { border: 'border-copper/40', bg: 'bg-copper/10', fg: 'text-copper-dark' };
  }
  if (v >= 3) {
    return { border: 'border-warning/40', bg: 'bg-warning/10', fg: 'text-warning' };
  }
  return { border: 'border-fg-tertiary/40', bg: 'bg-bg-tertiary', fg: 'text-fg-tertiary' };
}
